<template>
  <div
    class="current-itinerary"
    v-bind:style="{ borderRadius: viewMode ? '6px' :  '0 6px 6px 0' }"
    v-if="itinerary"
    id="scrollto"
  >
    <Leg
      v-for="(leg, i) in itinerary.legs"
      :key="i"
      :leg="leg"
      :prevLeg="i>0 ? itinerary.legs[i-1] : undefined"
      :nextLeg="i < itinerary.legs.length-1 ? itinerary.legs[i+1] : undefined"
      :isFirst="i===0"
      :fromPlace="fromPlace"
      :isLast="i===itinerary.legs.length-1"
      :toPlace="toPlace"
    />
  </div>
</template>

<script>
import { format } from 'date-fns';
import Leg from '@/components/Itinerary/Leg';
export default {
  name: 'current-itinerary',
  components: { Leg },
  props: {
    itinerary: Object,
    fromPlace: Object,
    toPlace: Object,
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  data: function() {
    return { format };
  },
  computed: {
    itineraryDuration: function() {
      if (!this.itinerary) {
        return undefined;
      }
      let durationString = '';
      let { duration } = this.itinerary;
      if (duration > 3600) {
        durationString += parseInt(duration / 3600) + ' timer, ';
        duration = duration % 3600;
      }
      if (duration > 60) {
        durationString += parseInt(duration / 60) + ' minutter';
        duration = duration % 60;
      }
      return durationString;
    },
    summary: function() {
      let summary = '';
      this.itinerary.legs.forEach(leg => {
        summary +=
          leg.mode.charAt(0) +
          leg.mode.substr(1, leg.mode.length - 1).toLowerCase() +
          '/';
      });
      summary = summary.substr(0, summary.length - 1);
      return summary;
    },
  },
};
</script>

<style lang="scss" scoped>
.current-itinerary {
  background-color: #fff;
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 30px 40px;
  overflow: hidden;
  word-break: break-word;
  hyphens: auto;
}

@media only screen and (min-width: 1201px) and (max-width: 1320px) {
  .current-itinerary {
    padding: 15px;
  }
}
@media only screen and (max-width: $tablet-landscape-max-width) {
  .current-itinerary {
    padding: 20px 30px;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  .current-itinerary {
    padding: 10px 15px;
    margin-top: 20px;
    border-radius: 6px !important;
  }
}
</style>
<style lang="scss">
.itinerary-row {
  display: flex;
  align-items: center;
  > * {
    flex-shrink: 0;
  }
  .left-slot {
    width: 50px;
  }
  .middle-slot {
    width: 40px;
    align-self: stretch;
  }
  .right-slot {
    flex: 1;
  }
}

@media only screen and (max-width: $mobile-max-width) {
  .itinerary-row {
    .left-slot {
      width: 42px;
    }
    .middle-slot {
      width: 37px;
    }
  }
}
</style>
